import {Component} from "react";
import md_logo from "../../../assets/img/logos/md-logo.png";
import verified_img from "../../../assets/img/registration/verified.png";
import back_icon from "../../../assets/img/registration/back-icon.png";
import React from "react";
import './style.scss';
import {connect} from "react-redux";
import {Col, Row, Button} from "reactstrap";
import IntlTelInput from "react-intl-tel-input";
import SocialLogins from './SocialMediaBtn/SocialMediaBtn'
import ImgBg from "./SideBgImg";

import LabelInput from "../../../components/Input/LabelInput/LabelInput";
import {Button as SementicBtn, Dropdown, Icon, Input} from "semantic-ui-react";
import LabelDropdown from "../../../components/Dropdown/LabelDropdown/LabelDropdown";
import OtpInput from 'react-otp-input';
import {MDBModal, MDBModalBody} from "mdbreact";

import * as util from "../../../util/Validator";
import * as common from "../../../const/Common/CommonFunc";
import * as DropDownConst from "../../../store/Reducer/DropDownConst";
import axiosAuth from "../../../axios/axios_authorization";
import Cookies from "js-cookie";
import apiConfig from "../../../axios/axios_api_services";
import Webcam from "react-webcam";
import * as actionCreator from "../../../store/Action";
import Countdown from "react-countdown";
import * as keys from "../../../const/key/Key";
import * as EmailValidator from "email-validator";

const initialState = {tab:1, screenshot: '', otp:'', isModal:false, validMobile: false, mobile:'', mobile_:'',
  firstName:'', lastName:'', gender:'', facingFront:true, identificationType:'NIC', identificationValue:'',date:Date.now() + 60000,
  email:'',validEmail:false, socialMediaToken:'', userSocialId:'', authType:'NORMAL'};

class App extends Component {

  state = Object.assign({}, initialState);

  componentWillMount(){
    if (this.props.match.params.code !== undefined){
      this.setState({
        tab:2,
        socialMediaToken:this.props.match.params.code,
        authType:'APPLE'
      })
    }
  }

  screenshotHandler = (screenshot) => {
    this.setState({
      screenshot: screenshot
    });
  };

  changeTab = (tab) => {
    this.setState({
      tab : tab
    })
  }

  // signUpAction =() => {
  //   // backend code
  //   this.changeTab(2)
  // }

  handleChange = (otp) => {
    this.setState({ otp });
  }

  verifyOtp = () => {
    this.setState({isModal:!this.state.isModal})
  }

  okAction = () => {
    this.setState({...initialState})
  }

  onHandleMobile = (condition, value, object, withdialcod) => {
    value = value.startsWith("00") ? "+" + value.substr(2) : value;
    condition = util.customMobileValidation(withdialcod.substr(1).replace(/\s/g, ""),condition);
    this.setState({
      validMobile:condition,
      mobile:value,
      mobile_: withdialcod.substr(1).replace(/\s/g, "")
    });
  };

  onHandleChange = name => e => {
    let value = e.target.value
    this.setState({
      [name] : value
    })

    if (name === 'email') {
      this.setState({
        validEmail: EmailValidator.validate(value)
      })
    }
  }

  onChangeGender = (e, { value }) => {
    this.setState({ gender: value })
  };

  handleFacingMode = () => {
    this.setState({facingFront: !this.state.facingFront})
  }

  caputureImageHandler = () => {
    let screenshot = this.refs.webcam.getScreenshot();
    this.setState({ screenshot })
  };

  removeImg = () => {
    this.setState({ screenshot: '' })
  }

  commonFunc = name => (obj) => {
    // console.log(`${name}:`,obj);
  };

  renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      return <a onClick={() => this.sendOtp()}>Resend Code</a>
    } else {
      return <span>{`0${minutes}`}:{seconds > 9 ? seconds : `0${seconds}`}</span>;
    }
  };

  socialLoginData = (obj) => {
    this.setState({
      tab:2,
      firstName:obj.firstName,
      lastName:obj.lastName,
      email:obj.email,
      socialMediaToken:obj.socialMediaToken,
      userSocialId:obj.userSocialId,
      authType:obj.authType
    })
  }

  validateSignUp = (type) => {
    // eslint-disable-next-line default-case
    switch (this.state.tab) {
      case 1:
        this.state.validMobile ? this.verifyMobile() : common.notifyMessage("Please enter valid mobile no")
        break;
      case 2:
        if (util.identityValueValidator(this.state.identificationValue, this.state.identificationType)) {
          this.state.firstName.trim() === '' ? common.notifyMessage("Please enter the first name") :
            this.state.lastName.trim() === '' ? common.notifyMessage("Please enter the last name") :
              this.state.authType !== 'NORMAL' && this.state.mobile.trim() === '' ? common.notifyMessage("Please enter the mobile") :
                this.state.authType !== 'NORMAL' && !this.state.validMobile ? common.notifyMessage("Please enter a valid mobile") :
                  // this.state.authType !== 'NORMAL' && this.state.email.trim() === '' ? common.notifyMessage("Please enter the email") :
                  //   this.state.authType !== 'NORMAL' && !this.state.validEmail ? common.notifyMessage("Please enter a valid email") :
                      this.state.gender.trim() === '' ? common.notifyMessage("Please select the gender") :
                        this.sendOtp()
        }
        break;
      case 3:
        this.state.otp.trim() === '' ? common.notifyMessage("Please enter the otp") :
          this.state.otp.length !== 5 ? common.notifyMessage("Please enter the otp correctly") :
            this.signUpAction(type)
    }
  }

  verifyMobile = () => {

    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    axiosAuth.get(apiConfig.CHECK_MOBILE_EXIST(this.state.mobile_), {headers: headers})
      .then(response => {
        if (!response.data.success) {
          this.changeTab(2)
          /*if (response.data.message.substring(0,2) === 'No') {
            this.changeTab(2)
          } else {
            common.warningAlert("Mobile number is already registered in the system. Please use a new number.")
            this.setState({validMobile: false, mobile:'', mobile_:''})
          }*/
        }else{
          common.warningAlert(response.data.message)
          this.setState({validMobile: false, mobile:'', mobile_:''})
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {

        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  }

  sendOtp = () => {

    this.props.spinnerHandler(true);
    const headers = {
      "Content-Type": "application/json"
    };

    axiosAuth.post(apiConfig.USER_SIGN_UP_SEND_OTP,{mobile:this.state.mobile_}, {headers: headers})
      .then(response => {
        if (response.data.success) {
          if (this.state.tab === 2) this.changeTab(3)
          this.setState({
            date: Date.now() + 60000,
            otp:''
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {

        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  }

  signUpAction = (type) => {
    this.props.spinnerHandler(true);

    const data={
      "first_name": this.state.firstName,
      "last_name": this.state.lastName,
      "mobile": this.state.mobile_,
      "identification_type": this.state.identificationType,
      "identification_value": this.state.identificationValue,
      "gender": this.state.gender,
      "photo_path": this.state.screenshot === '' ? null : this.state.screenshot,
      "email":this.state.email,
      "social_media_token":this.state.socialMediaToken,
      "user_social_id":this.state.userSocialId,
      "auth_type":this.state.authType,
      "is_web_sign_up":true
    }

    const headers = {
      "Content-Type": "application/json"
    };

    axiosAuth.post(apiConfig.USER_SIGN_UP(this.state.otp), data, {headers: headers})
      .then(response => {
        if (response.data && (response.data.success === undefined || response.data.success)) {
          if (type === 'verify') {
            this.verifyOtp()
          } else {
            if(response.data.message) common.notifyMessage(response.data.message, 2)
            this.setState({...initialState})
          }
        } else {
          common.warningAlert(response.data.message)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {

        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  }

  backHandler = () => {
    let {tab} = this.state;
    if(tab !== 1 && tab === 2 ) {
      this.setState({...initialState})
    } else {
      this.setState({tab: tab - 1 })
    }
  }

  render() {
    let {tab, screenshot, otp, isModal, mobile,mobile_, firstName, lastName, gender, facingFront, identificationType,
    identificationValue, date, authType, email} = this.state;

    return (
      <Row style={{background:'white'}} className={'public-web-signup-layout'}>
        <ImgBg pgType={tab === 2 ? 'signUp' : 'signIn'}/>
        <Col className='signUp-div'>
          {tab !==1 ? <div className={"back-icon-wrapper"} onClick={this.backHandler}>
            <img src={back_icon} alt={"back-icon"} />
          </div>:null}
          <img src={md_logo} alt={"."} id={tab !== 3 ? 'md_logo' : 'md_logo_verify'}/>
          {
            tab === 1 ?
              <>
                <p className={'title'}>Create an Account</p>
                <div className={"mt-5"}>
                  {/*<Lbl>Mobile</Lbl>*/}
                  <IntlTelInput
                    style={{width: '100%', marginBottom:'30px'}}
                    type={"text"}
                    fieldName={"Mobile Number"}
                    value={mobile}
                    containerClassName="intl-tel-input dashboard-intl"
                    inputClassName="form-control"
                    onPhoneNumberChange={this.onHandleMobile}
                    required={true}
                    preferredCountries={['lk']}
                    defaultCountry={"lk"}
                    nationalMode={false}
                    icon='mobile alternate'
                    placeholder="Mobile Number"
                  />
                </div>
                <Button className={'done-btn'} onClick={() => this.validateSignUp('')}> Sign up</Button>
                <SocialLogins setData={this.socialLoginData} type={'sign-up'}/>
                {/*<div className={'sign-up-link'}>*/}
                  {/*<p>Already have an account?*/}
                    {/*<span onClick={() => this.props.history.push(routeConstants.PUBLIC_WEB_SIGN_IN_PAGE)}> Sign in</span>*/}
                  {/*</p>*/}
                {/*</div>*/}
              </> : tab === 2 ?
              <>
                <p className={'title mb-3'}>Create an Account</p>
                {
                  screenshot === '' ?
                    <Webcam
                      forceScreenshotSourceSize={true}
                      mirrored={true}
                      imageSmoothing={true}
                      screenshotQuality={100}
                      onUserMediaError={this.commonFunc('onUserMediaError')}
                      onUserMedia={this.commonFunc('onUserMedia')}
                      videoConstraints={{facingMode: facingFront ? "user" : { exact: "environment" }}}
                      style={{width: '100%'}}
                      audio={false}
                      screenshotFormat={"image/jpeg"}
                      ref='webcam'
                    /> :
                    <img src={screenshot} width='200px'/>
                }

                <Row>
                  <Col className={"align-center"} style={{ margin: "1vh 0 0" }}>
                    {
                      screenshot === '' ? <>
                          <SementicBtn id={'sementic-btn'} onClick={() => this.caputureImageHandler()}>
                            <Icon name='camera'/>Capture
                          </SementicBtn>
                          <SementicBtn  id={'sementic-btn'} onClick={() =>this.handleFacingMode()}>
                            <Icon name='sync'/>Rotate
                          </SementicBtn>
                      </> :
                        <SementicBtn id={'sementic-btn'} onClick={() => this.removeImg()}>
                          <Icon name='trash alternate'/>Remove
                        </SementicBtn>
                    }
                  </Col>
                </Row>
                <div className='identify-div mt-4'>
                  <Dropdown
                    id={'identify-dropdown'}
                    button
                    value={identificationType}
                    options={DropDownConst.Identifications()}
                    onChange={
                      (e, {value}) => {
                        this.setState({
                          identificationType: value, identificationValue:''
                        })
                      }
                    }
                  /><Input className={'identify-inpt'} placeholder={"Identification Value"} value={identificationValue} onChange={this.onHandleChange('identificationValue')}/>
                </div>
                <LabelInput
                  tagText={"First Name"}
                  placeholder={"First Name"}
                  value={firstName}
                  onChange={this.onHandleChange('firstName')}
                />
                <LabelInput
                  tagText={"Last Name"}
                  placeholder={"Last Name"}
                  value={lastName}
                  onChange={this.onHandleChange('lastName')}
                />
                {
                  authType !== 'NORMAL' && <>
                    <div className={"fb-mobile"}>
                      <label className="label ui dashboard-mobile-lbl">Mobile </label>
                      <IntlTelInput
                        type={"text"}
                        fieldName={"Mobile Number"}
                        value={mobile}
                        containerClassName="intl-tel-input dashboard-intl"
                        inputClassName="form-control"
                        onPhoneNumberChange={this.onHandleMobile}
                        required={true}
                        preferredCountries={['lk']}
                        defaultCountry={"lk"}
                        nationalMode={false}
                        placeholder={'Mobile'}
                      />
                    </div>
                    {
                      email !== '' &&
                      <LabelInput
                        tagText={"Email"}
                        placeholder={"Email"}
                        value={email}
                        disable={true}
                        inputClass={"gray-background"}
                        onChange={this.onHandleChange('email')}
                      />
                    }
                  </>
                }
                <LabelDropdown
                  // disable={this.state.isVisitor}
                  tagText={"Gender"}
                  placeholder={"Gender"}
                  options={DropDownConst.gender}
                  value={gender}
                  onChange={this.onChangeGender}
                />
                <Button className={'done-btn'} onClick={() => this.validateSignUp('')}>Create Account</Button>
              </> :
              <>
                <p className={'title'}>Verify Number</p>
                <p>Enter the OTP sent to  <span>{mobile_}</span></p>
                <OtpInput
                  value={this.state.otp}
                  onChange={this.handleChange}
                  numInputs={5}
                  inputStyle={{margin:'0 10px 20px', width:'2.5em'}}
                  containerStyle={{justifyContent:'center'}}
                  // focusStyle={{border: '1px solid #FFAD33!important'}}
                />
                <Countdown key={date} date={date} renderer={this.renderer}/>

                <div>
                  <Button style={{width:'45%', marginRight:'8px'}} className={'done-btn'} onClick={() => this.validateSignUp('verify')}>Verify</Button>
                  <Button style={{width:'45%'}} className={'done-btn'} onClick={() => this.validateSignUp('add')}>Verify and Add New</Button>
                </div>

              </>
          }
          {
          isModal &&
          <MDBModal isOpen={isModal}  toggle={() => this.verifyOtp()} size="sm">
            <MDBModalBody>
              <div>
                <img src={verified_img} width='auto' height='42px'/>
                <p className={'title'}>Congratulations!</p>
                <p  style={{margin:0}}>You have successfully create the account.</p>
                <Button className={'done-btn'} style={{width:'75%'}} onClick={() => this.okAction()}>Ok</Button>
                <p className="text-center download-text">Download the App Now!</p>
                <div className='store-div'>
                  <a className="store-btn wrapper-1" role="button"
                     href={keys.EVENT_APP_PLAY_STORE_APP}>
                    <img src="/app-assets/play-store-badge.png" alt="play-store-badge"/>
                  </a>
                  <a className="store-btn wrapper-2" role="button"
                     href={keys.EVENT_APP_APP_STORE_APP}>
                    <img src="/app-assets/app-store-badge.svg" alt="app-store-badge"/>
                  </a>
                </div>

              </div>
            </MDBModalBody>
          </MDBModal>
        }
        </Col>
      </Row>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(null, mapDispatchToProps)(App);
